<template>
	<div class="post_container full" style="position: relative;" :class="{hidden:hidden}">
		<div class="flex" style="font-size: 14px;align-items: center" v-html="notice"></div>
		<div>
			<vxe-grid :ref="gridref" v-bind="gridOptions" :key="gridKey" v-if="gridOptions" :size="size"
				@toolbar-button-click="toolbarButtonClickEvent" :loading="loading" @edit-closed="editClosed" keep-source
				:max-height="height" @filter-change="filterChange" :span-method="mergeRowMethod">
			</vxe-grid>
		</div>
	</div>
</template>
<style>
	.search_department>* {
		height: 28px !important;

	}

	.headerCellStyle {}
</style>
<style scoped>
	.hidden {
		display: none;
	}

	/* 	.post_container {
		padding: 0 10px;
		box-sizing: border-box;

	} */

	.toolbar {
		padding: 0 10px;
	}
</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import Store from '@/store/store.js'

	export default {
		mixins: [listMixins],
		props: {
			formCreateInject: {
				type: Object,
				default: () => {
					return null
				}
			},
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			mainModuleName: {
				type: String,
				default: () => {
					return ""
				}
			},
			mainid: {
				type: [String, Number],
				default: () => {
					return 0
				}
			},
			boxindex: {
				type: [String, Number],
				default: () => {
					return 0
				}
			},
			moduleName: {
				type: String,
				default: () => {
					return ""
				}
			},
			disabled: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			size: {
				type: String,
				default: () => {
					return "mini"
				}
			},
			buttons: {
				type: Array,
				default: () => {
					return []
				}
			},
			height: {
				type: [String, Number],
				default: () => {
					return ''
				}
			},
			fields: {
				type: Array,
				default: () => {
					return []
				}
			},
			pagerConfig: {
				type: Object,
				default: () => {
					return {
						currentPage: 1,
						pageSize: 20,
						enabled: true
					}
				}
			},
			formConfig: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				notice: null,
				footerField: [],
				gridKey: Math.random(),
				gridOptions: null,
				gridref: this.moduleName + Math.random() + '_table',
				relationid: [],
				uniqueItem: {},
				hidden: this.disabled,
				loading: false,
				tableoOperateButtons: Store.store.state.system.tableoOperateButtons,
				exportConfig: {
					filename: this.moduleName + '明细',
					type: 'xlsx',
					remote: false,
					mode: 'current'
				}
			}
		},
		watch: {
			mainid(val) {
				if (val != 0) {
					this.loadTableData()
				}
			},
			disabled(v) {
				this.hidden = v
			},
			footerField(v) {
				this.list_footerField = v
			}
		},
		created() {
			this.initList()
		},
		mounted() {
			this.list_footerField = this.footerField
			this.store.table = this.$refs[this.gridref]
			this.store.container = this

			// console.log(this.fields)
		},
		computed: {

		},

		methods: {
			initList() {
				this.initToolbarButton()
				this.initOperateButton()
				this.initOption()
			},
			initToolbarButton() {
				let tools = []
				let tableToolbarButtons = [{
					code: 'add',
					name: this.getAddButtonName(),
					// type: 'text',
					status: 'primary',
					// icon: 'vxe-icon-square-plus',
					visible: !this.findButton('add'),
					buttonRender: {
						...this.findButtonRender('add'),
						events: {
							add: (data) => {
								this.add(data)
							},
							boxdataload: (e) => {
								this.$emit('boxdataload', e)
							},
							boxdatapenetrate: (e) => {
								this.$emit('boxdatapenetrate', e)
							}
						}
					}
				}, {
					code: 'import',
					name: '导入',
					status: 'success',
					visible: !this.findButton('import')
				}, {
					code: 'importtemplate',
					name: '导入模板',
					status: 'info',
					visible: !this.findButton('importtemplate')
				}, {
					code: 'export',
					name: '导出',
					status: 'danger',
					visible: !this.findButton('export')
				}]

				let customTableToolbarButtons = Store.store.state.tableToolbarButtons
				customTableToolbarButtons = JSON.parse(JSON.stringify(customTableToolbarButtons))
				customTableToolbarButtons.forEach((item) => {
					item.visible = !this.findButton(item.code)
				})
				this.toolbarButton = tableToolbarButtons.concat(customTableToolbarButtons)
				this.tools = tools
				// console.log(tableToolbarButtons)
			},
			initOperateButton() {
				let customTableoOperateButtons = Store.store.state.tableoOperateButtons
				let tableoOperateButtons = this.tableoOperateButtons.concat(customTableoOperateButtons)
				let buttons = []
				tableoOperateButtons.forEach((ctob) => {
					if (!this.findButton(ctob.code)) {
						buttons.push({
							code: ctob.code,
							content: ctob.name,
							inrow: ctob.inrow,
							status: ctob.status
						})
					}
				})
				if (!this.findButton('del')) {
					buttons.push({
						code: 'del',
						content: '删除',
						inrow: true,
						status: 'danger',
					})
				}

				this.operateButton = buttons
			},
			initEditRule() {
				let editRules = {}
				this.fields.forEach((item) => {
					item.validate.forEach((val) => {
						val.pattern = val.pattern ? eval(val.pattern) : undefined
					})
					editRules[item.field] = item.validate
				})
				return editRules
			},
			getColumns() {
				let columns = []
				if (this.formCreateInject && this.formCreateInject.rule.config && this.formCreateInject.rule.config
					.checkbox) {
					columns = [{
						type: 'checkbox',
						width: 50,
						fixed: 'left'
					}, {
						type: 'seq',
						width: 50,
						fixed: 'left'
					}]
				} else {
					columns = [{
						type: 'seq',
						width: 50,
						fixed: 'left'
					}]
				}
				this.fields.forEach((item, index) => {
					let formatter = null
					let titlePrefix = {}
					if (item.props.unique) {
						this.relationid.push({
							tabledataid: item.field,
							boxdataid: item.props.quote
						})
					}
					if (item.props.readonly) {
						titlePrefix.content = "只读"
						titlePrefix.icon = 'vxe-icon-eye-fill'
					} else if (item.props.disabled) {
						titlePrefix.content = "禁用"
						titlePrefix.icon = 'vxe-icon-lock-fill'
					} else {
						titlePrefix.content = "编辑"
						titlePrefix.icon = 'vxe-icon-edit'
					}
					if (item.virtual) {
						titlePrefix.content = "引用"
						titlePrefix.icon = 'vxe-icon-link'
					}
					if (item.props.unique) {
						titlePrefix.content = "唯一"
						titlePrefix.icon = 'vxe-icon-star-fill'
						this.uniqueItem[item.field] = item.props.quote
					}
					if (item.type == '$inputNumber') {
						formatter = ({
							row
						}) => {
							return row[item.field]
						}
					}
					if (item.formatter) {
						formatter = ({
							row
						}) => {
							return window.systemMethods.formatter(row, item)
						}
					}
					let obj = {
						field: item.field,
						title: item.title,
						// filters:item.props.search?[{data:''}]:null,
						// filterRender:{
						// 	name:'$input'
						// },
						//cellType:'string',
						fixed: item.fixed ? item.fixed : '',
						minWidth: item.width ? item.width : (index == this.fields.length - 1 ? '' : 120),
						//minWidth: item.width ? item.width : 120,
						visible: !item.hidden,
						titlePrefix: titlePrefix,
						showHeaderOverflow: 'tooltip',
						editRender: {
							name: item.type,
							enabled: !item.props.disabled,
							props: item.props ? item.props : {},
							events: {
								change: ({
									row,
									column,
									$table
								}, e) => {									
									this.$emit('tablefieldChange', {
										itemProps: item.props,
										store: this.store,
										table: this.$refs[this.gridref],
										$table: $table,
										moduleName: this.moduleName,
										componentparam: e,
										data: {
											row: row,
											column: column,
										}
									})
								},
								inputButtonclick: ({
									row,
									column,
									$table
								}, e = null) => {
									this.$emit('tablefieldButtonclick', {
										e: e,
										itemProps: item.props,
										store: this.store,
										table: this.$refs[this.gridref],
										$table: $table,
										moduleName: this.moduleName,
										data: {
											row: row,
											column: column,
										}
									})
								},
								preview: (e) => {
									this.$emit('preview', e)
								}
							}
						},
						formatter: formatter,
					}
					columns.push(obj)
				})
				columns.push({
					title: '操作',
					width: this.operateButton.length * 60,
					fixed: 'right',
					align: 'center',
					visible: this.operateButton.length != 0,
					cellRender: {
						bind: this,
						name: '$operateButton',
						buttons: this.operateButton
					}
				})
				return columns

			},
			initOption() {
				let gridOptions = this.getOption()
				gridOptions.pagerConfig = this.pagerConfig
				gridOptions.proxyConfig.autoLoad = false
				gridOptions.cellStyle = this.cellStyle
				gridOptions.maxHeight = this.maxHeight
				gridOptions.toolbarConfig = {
					zoom: true,
					tools: [{
						toolRender: {
							name: '$batchmodify',
							props: {
								fields: this.fields,
								buttons: this.toolbarButton
							},
							events: {
								submit: (data) => {
									this.toolsSubmit(data)
								}
							}
						}
					}],
					perfect: false,
					size: this.size,
					buttons: this.toolbarButton
				}
				gridOptions.filterConfig = {
					remote: true,
					events: {
						submit: this.filterSubmit
					}
				}
				gridOptions.treeConfig = {}
				gridOptions.editConfig = {
					trigger: 'click',
					mode: 'cell',
					showStatus: true,
					activeMethod: this.activeCellMethod,
					showIcon: false
				}
				gridOptions.checkboxConfig = {
					trigger: 'cell'
				}
				gridOptions.validConfig = {
					autoPos: true,
					showMessage: false,
				}
				gridOptions.importConfig = {
					types: ['xls', 'xlsx'],
					remote: true,
					importMethod: this.importMethod
				}
				gridOptions.exportConfig = {
					types: ['xls', 'xlsx'],
					remote: true,
					exportMethod: this.exportMethod
				}
				gridOptions.formConfig = this.formConfig
				gridOptions.columns = this.getColumns()
				gridOptions.editRules = this.initEditRule()
				if (this.beforeCreateGrid) {
					this.beforeCreateGrid(gridOptions.formConfig, gridOptions.columns, gridOptions)
				}
				this.gridOptions = gridOptions

			},
			getOption() {
				let list_getOption = this.list_getOption()
				this.list_gridOptions = list_getOption
				return list_getOption
			},
			list(page, form, other) {
				return new Promise(resolve => {
					if (this.mainModuleName) {
						this.$api[this.mainModuleName].list({
							...page,
							...form,
							...other,
							...{
								id: this.mainid,
								son: this.moduleName,
								boxindex: this.boxindex,
							}
						}).then((res) => {
							res.list.map((item) => {
								for (let i in item) {
									if (i.match(/.*time$/g)) {
										item[i] = item[i] * 1000
									}
									if (i.match(/.*file$/g)) {
										item[i] = item[i] ? item[i] : []
									}
								}
							})
							resolve(res)
						}, () => {
							resolve()
						})
					} else {
						resolve()
					}
				})
			},
			copy(row) {
				let copydata = JSON.parse(JSON.stringify(row))
				delete copydata._X_ROW_KEY
				delete copydata.id
				this.$refs[this.gridref].insertAt(copydata, -1)
				this.$emit('afterTableInsert', {
					obj: row,
					data: null,
					table: this.$refs[this.gridref],
					moduleName: this.moduleName,
				})
			},

			getForm() {

			},
			getTableToolbarButtons() {
				return this.gridOptions.toolbarConfig.buttons
			},
			operateButtonClickEvent(e) {
				if (this[e.code]) {
					this[e.code](e.data)
				} else {
					this.$message.error(e.code + '方法不存在')
				}

			},
			placeholdRow(num) {
				for (let i = 0; i < num; i++) {
					this.$refs[this.gridref].insertAt({}, -1)
				}
			},
			toolbarButtonClickEvent(e) {
				if (e.code == 'add') {
					let obj = {
						obj: {},
						table: this.$refs[this.gridref],
						moduleName: this.moduleName
					}
					this.setDefaultValue(obj.obj)

					new Promise((reslove) => {
						obj.next = reslove
						this.$emit('tableAdd', obj)
					}).then(() => {
						if (Array.isArray(obj.obj)) {
							this.$refs[this.gridref].insertAt(obj.obj, -1).then(()=>{
								this.$emit('afterTableInsert', {
									obj: obj.obj,
									data: obj.obj,
									table: this.$refs[this.gridref],
									moduleName: this.moduleName,
								})
							})
						} else if (obj.obj !== null) {
							this.$refs[this.gridref].insertAt(obj.obj, -1).then(()=>{
								this.$emit('afterTableInsert', {
									obj: obj.obj,
									data: obj.obj,
									table: this.$refs[this.gridref],
									moduleName: this.moduleName,
								})
							})
						} else {
							return
						}
						
						
						
						// if (Array.isArray(obj.obj)) {
						// 	obj.obj.forEach((item) => {
						// 		this.$refs[this.gridref].insertAt(item, -1)
						// 	})														
						// } else if (obj.obj !== null) {
						// 	this.$refs[this.gridref].insertAt(obj.obj, -1)
						// } else {
						// 	return
						// }

					})
				} else {
					this.$emit(e.code, {
						table: this.$refs[this.gridref],
					})
				}
				// if (e.code == 'add') {
				// 	this.add()
				// }
				// if (e.code == 'submit') {
				// 	this.submit()
				// }

			},
			getGrid() {
				return this.$refs[this.gridref]
			},
			loadTableData(other = {}) {
				this.$refs[this.gridref].commitProxy('query', other).then(() => {
					this.$emit('dataload', {
						module: this.moduleName,
						data: this.getTableData().fullData
					})
				})
			},
			findButton(code) {
				let disabled = true
				this.buttons.forEach((item) => {
					if (item.code == code) {
						disabled = item.disabled
					}
				})
				return disabled
			},
			getAddButtonName() {
				let name = '新增'
				this.buttons.forEach((item) => {
					if (item.code == 'add') {
						name = item.name
					}
				})
				return name
			},
			findButtonRender(code) {
				let buttonRender = null
				this.buttons.forEach((item) => {
					if (item.code == code) {
						buttonRender = item.buttonRender ? item.buttonRender : null
					}
				})
				//console.log(this.buttons)
				return buttonRender
			},
			loadData(e) {
				this.$refs[this.gridref].loadData(e.data)
			},
			getTableData() {
				return this.$refs[this.gridref].getTableData()
			},
			toolsSubmit(data) {
				this.$emit('toolsSubmit', data)
			},
			add(data) {
				data.data.forEach((item, index) => {
					let obj = {}
					this.setDefaultValue(obj)
					let fullData = this.$refs[this.gridref].getTableData().fullData
					this.fields.forEach((field) => {
						if (field.props.moduleName != 'emun_value') {
							if (field.type == '$quote' || (window.systemData[field.type.replace(/\$/,
										'')] &&
									field.props.moduleName != field.type.replace(/\$/, ''))) {
								obj[field.field] = item[field.props.quote]
							} else {
								obj[field.field] = item['import_' + field.field] ? item['import_' + field
									.field] : (obj[field.field] ? obj[field.field] : null)
							}
						}

					})

					this.$emit('tableInsert', {
						obj: obj,
						data: data.data[index],
						table: this.$refs[this.gridref],
						moduleName: this.moduleName,
					})
					if (obj.tablestopinsert) {
						return
					}
					let search = -1
					if (this.relationid) {
						search = fullData.findIndex((_item) => {
							if (Array.isArray(this.relationid)) {
								let samenum = 0
								for (let i = 0; i < this.relationid.length; i++) {
									if (_item[this.relationid[i].tabledataid] && _item[this.relationid[i]
											.tabledataid] == item[this.relationid[i]
											.boxdataid]) {
										samenum++
									}
								}
								if (this.relationid.length == samenum) {
									if (samenum == 0) {
										return false
									} else {
										return true
									}

								} else {
									return false
								}

							} else {
								return _item[this.relationid.tabledataid] == item[this.relationid
									.boxdataid]
							}

						})
					}

					if (search === -1) {
						this.$refs[this.gridref].insertAt(obj, -1).then((row) => {
							this.$emit('afterTableInsert', {
								obj: row,
								data: data.data[index],
								table: this.$refs[this.gridref],
								moduleName: this.moduleName,
							})
						})
					}
				})
			},
			setRelationId(relationid) {
				this.relationid = relationid
			},
			del(row) {
				//console.log(row, 'delete')
				this.$refs[this.gridref].remove(row)
				this.$emit('aftertabledelete', {
					obj: row,
					moduleName: this.moduleName,
					table: this.$refs[this.gridref]
				})
			},
			clear() {
				let fullData = this.$refs[this.gridref].getTableData().fullData
				fullData.forEach((item) => {
					this.$refs[this.gridref].remove(item)
				})
			},
			submit() {
				return new Promise((resolve, reject) => {
					let grid = this.$refs[this.gridref]
					let insertRecords = []
					let removeRecords = []
					let updateRecords = []
					if (!this.store.form.extra.copyid) {
						let tabledata = grid.getRecordset()
						//console.log(tabledata,123)
						insertRecords = tabledata.insertRecords.reverse()
						removeRecords = tabledata.removeRecords
						updateRecords = tabledata.updateRecords
					} else {
						let tabledata = grid.getTableData().fullData
						tabledata.forEach((item) => {
							let obj = {}
							for (let i in item) {
								if (i != 'id' && i != this.store.form.name + 'id') {
									obj[i] = item[i]
								}
							}
							insertRecords.push(obj)
						})
					}
					// if (insertRecords.length <= 0 && removeRecords.length <= 0 && updateRecords.length <= 0) {
					// 	resolve(true)
					// }
					grid.validate(true, (res) => {
						// console.log(res)
						if (!res) {
							let obj = {
								insertRecords: insertRecords,
								removeRecords: removeRecords,
								updateRecords: updateRecords
							}
							resolve(obj)
						} else {
							for (let i in res) {
								this.$message.error('缺少必填项：' + res[i][0].column.title)
							}
							reject()
							//console.log(res)
						}
					})
				})
			},
			activeCellMethod(e) {
				let cell = e.$table.getColumnNode(e.cell)
				if (cell.item.editRender.props && cell.item.editRender.props.readonly) {
					return false
				} else {
					return true
				}


			},
			editClosed() {

			},
			filterChange({
				filterList
			}) {
				let other = {}
				filterList.forEach((item) => {
					other[item.field] = item.datas[0]
				})
				this.loadTableData(other)
			},
			footerMethod({
				columns,
				data
			}) {
				let footData = []
				columns.forEach((item) => {
					if (item.type == 'seq') {
						footData.push('合计')
					} else {
						let obj = this.footerField.find((obj) => {
							return obj.field == item.field
						})
						if (obj) {
							footData.push(this.sum(item.field, data, obj.toFixed))
						} else {
							footData.push('')
						}
					}
				})
				//console.log(columns, data)

				return [
					footData
				]
			},
			mergeRowMethod() {

			},
			// mergeRowMethod({
			// 	row,
			// 	_rowIndex,
			// 	column,
			// 	visibleData
			// }) {
			// 	//console.log(row)
			// 	const fields = ['stockcode']
			// 	const cellValue = row[column.field]
			// 	if (cellValue && fields.includes(column.field)) {
			// 		const prevRow = visibleData[_rowIndex - 1]
			// 		let nextRow = visibleData[_rowIndex + 1]
			// 		if (prevRow && prevRow[column.field] === cellValue) {
			// 			return {
			// 				rowspan: 0,
			// 				colspan: 0
			// 			}
			// 		} else {
			// 			let countRowspan = 1
			// 			while (nextRow && nextRow[column.field] === cellValue) {
			// 				nextRow = visibleData[++countRowspan + _rowIndex]
			// 			}
			// 			if (countRowspan > 1) {
			// 				return {
			// 					rowspan: countRowspan,
			// 					colspan: 1
			// 				}
			// 			}
			// 		}
			// 	}
			// },
			setDefaultValue(obj) {
				this.fields.forEach((item) => {
					if (item.value === 'currentstaff') {
						obj[item.field] = Store.store.state.system.user.id
					} else if (item.value === 'currentdepartment') {
						obj[item.field] = Store.store.state.system.user.departmentid
					} else {
						if (typeof item.value == 'object') {
							obj[item.field] = JSON.parse(JSON.stringify(item.value))
						} else {
							obj[item.field] = item.value
						}

					}
				})
			},
			sum(field, data, toFixed) {
				let sum = 0
				data.forEach((item) => {
					for (let i in item) {
						if (i == field) {
							sum = sum + (isNaN(parseFloat(item[i])) ? 0 : parseFloat(item[i]))
						}
					}
				})
				return sum.toFixed(toFixed)
			},
			footerCellClassName() {
				return 'footerCellColor'
			},

			cellStyle() {

			},
			importMethod(e) {
				e.moduleName = this.moduleName
				if (this.store.form && this.store.form.importMethod) {

					return this.store.form.importMethod(e)
				}

			},
			exportMethod(e) {
				if (this.store.form && this.store.form.exportMethod) {
					return this.store.form.exportMethod(e)
				} else {
					e.$table.exportData(this.exportConfig)
				}
			}

		},
		components: {

		}
	}
</script>